import socialSecurityFA from './fa/fa.json'

const socialSecurityMessages = {
  fa: { ...socialSecurityFA },
}

export default socialSecurityMessages
